export const DASHBOARD = "dashboard"
export const ASSET = "asset"
export const PLAYLIST = "playlist"
export const MEDIAPLAYER = "mediaplayer"
export const NOTIFICATION = "notification"
export const USERPROFILE = "userprofile"
export const PASSWORDRESET = "passwordreset"
export const LOGIN = "login"
export const IMPRINT = "imprint"
export const ADMIN = "admin"

export const PUBLIC_VIEWS = [LOGIN, IMPRINT, PASSWORDRESET]



// WEBPACK FOOTER //
// ./src/app/component/app/view.js